export default "__VITE_ASSET__1Yed1TLf__"